cb.define(['common/common_VM.Extend.js'], function (common) {


    var PM_pmc_giftpreferentiallist_filterVM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            var userViewModel = cb.rest.AppContext.user;
            viewmodel.on("afterInit", function () {
                if (!userViewModel.registInfo || !userViewModel.registInfo.DST || userViewModel.cType == 3) {
                    viewmodel.get("shop").setVisible(false);
                } else if (userViewModel.registInfo.DST != undefined && userViewModel.registInfo.DST != null
                    && userViewModel.registInfo.DST && userViewModel.cType != 3) {
                    if (viewmodel.get('iGiftType')) {
                        let auditStatusModels = viewmodel.get('iGiftType').getFromModel();
                        let dataSources = auditStatusModels.getState('dataSource');
                        let newSources = [];
                        let flags = false
                        dataSources && dataSources.forEach(datas => {
                            if (datas.value == 5) {
                                flags = true
                            }
                            newSources.push({value: datas.value, nameType: 'text', text: datas.text});
                        });
                        if (!flags) {
                            newSources.push({value: "5", nameType: 'text', text: '按关键词'});
                        }
                        auditStatusModels.setDataSource(newSources);
                    }
                }
                common.displayProductFiltering(viewmodel, userViewModel);
            });
        }
    };
    try {
        module.exports = PM_pmc_giftpreferentiallist_filterVM_Extend;
    } catch (error) {

    }
    return PM_pmc_giftpreferentiallist_filterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_giftpreferentiallist_filterVM.Extend.js